// biome-ignore lint/suspicious/noControlCharactersInRegex: <3rd-party library>
const InvisibleCharsRegExp = /[\x00-\x1F]/g;

export const removeNullCharacters = (str: string, replaceInvisible = false) => {
  if (!InvisibleCharsRegExp.test(str)) {
    return str;
  }
  if (replaceInvisible) {
    return str.replaceAll(InvisibleCharsRegExp, (m) => (m === '\x00' ? '' : ' '));
  }
  return str.replaceAll('\x00', '');
};
